// @flow
import './default-bundle';

import HomePageWhyChooseLumeraPopup from '@components/popups/home_page/WhyChooseLumera';

ReactOnRails.register({
  HomePageWhyChooseLumeraPopup
});
